import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, t as translate } from "../i18n/translations.js";

const I18nContext = createContext(null);
const STORAGE_KEY = "zyncfit_language";

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || "nl");

  const setLanguage = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem(STORAGE_KEY, newLang);
  }, []);

  // Load language for a specific shop domain (called when shop changes)
  const loadShopLanguage = useCallback(async (shopDomain) => {
    if (!shopDomain) return;
    try {
      const res = await fetch(`/api/settings/public/${encodeURIComponent(shopDomain)}`);
      if (res.ok) {
        const data = await res.json();
        if (data?.language) {
          setLang(data.language);
          localStorage.setItem(STORAGE_KEY, data.language);
        }
      }
    } catch {}
  }, []);

  const t = useCallback((key, params) => translate(lang, key, params), [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLanguage, loadShopLanguage, t, translations: translations[lang] || translations.nl }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
